import Vue from 'vue'
import Vuex from 'vuex'

import commons from './modules/commons'
import user from './modules/user'
import vessel from './modules/vessel'
import estimating from './modules/estimating'
import route from './modules/route'
import distance from './modules/distance'
import estiDistance from './modules/estiDistance'
import port from './modules/port'

Vue.use(Vuex)

const state = {
  vesselDataLoaded: false
}

// mutations
const mutations = {
  setVesselDataLoaded (state, payload) {
    state.vesselDataLoaded = payload
  }

}

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    commons,
    vessel,
    estimating,
    estiDistance,
    route,
    distance,
    user,
    port
  }
})
